import UserRowAvatar from './UserRowAvatar';

const userAxis = {
  key: 'user',
  shiftField: 'users',
  headerTitle: 'Users',
  unassignedLabel: 'Unassigned',
  RowAvatar: UserRowAvatar,
  getAssignment: (row) => ({ users: row ? [row.id] : [] }),
  getReassignArgs: (previousId, newId) => ({
    previousUserId: previousId,
    newUserId: newId,
    updateUsers: true,
  }),
};

export default userAxis;
